import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { HostApiService } from 'lib-host-interface';
import { delay, of } from 'rxjs';

export const mockCompanyInfo = {
  firstName: 'Amy',
  middleName: null,
  lastName: 'Bishop',
  crdFirmId: '3030',
  userId: 'BishopA',
  email: 'bishopa@finra.org',
  phoneNumber: '',
  firmName: 'Rocket Mortgage, LLC',
};

export const mockCompanyEntitlements = ['MU3', 'MU3Submitter', 'Administrator'];

export const mockAppHostUser = {
  info: mockCompanyInfo,
  profile: {
    tmp: 'test',
  },
  preferences: {
    startingRoute: 'test',
    language: 'test',
  },
  setLanguage: () => {},
};

@Injectable({
  providedIn: 'root',
})
export class hostApiMockService extends HostApiService {
  constructor(@Inject(DOCUMENT) document: Document) {
    super(document);
  }

  user = {
    info: of(mockCompanyInfo).pipe(delay(1000)),
  } as any;

  entitlements = {
    classification: of('Company').pipe(delay(1300)),
    permissions: of(mockCompanyEntitlements).pipe(delay(1300)),
  } as any;
}
